import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'

// Declares every design token as a custom property on :root, and loads the two
// variable faces. It must be imported before the theme is applied, because the
// theme's styleOverrides resolve against these properties rather than baking in
// literals — see src/design/theme.ts.
import 'Design/tokens.css'
import { theme } from 'Design/theme'

export const AppThemeProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  // `theme` is created at module scope in Design/theme, not here. Calling
  // createTheme in this render body rebuilt the theme object on every render
  // and invalidated every Emotion cache below it.
  return (
    // enableCssLayer puts MUI's own styles into @layer mui.*, so anything
    // unlayered — a stray stylesheet, an inline sx — still wins while the
    // migration is in flight.
    <StyledEngineProvider enableCssLayer>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
